import React from 'react';
// import useStyles from './styles';
import { Tooltip, TextField } from "@material-ui/core";

export default function Text({ field, onChange, errors = {}, variant = "outlined", value, small = false,disabled=false }) {
  // const classes = useStyles();
  let iserror = errors[field.name] ? true : false;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <Tooltip
      title={field.comment || ''}
      disableHoverListener={field.comment ? false : true}
      placement="top-start"
      disableFocusListener={field.comment ? false : true}
      disableTouchListener={field.comment ? false : true}
    >
      <TextField
        id={field.name}
        name={field.name}
        error={iserror}
        required={field.required === 'true' ? true : false}
        label={field.label}
        multiline
        size={small ? "small" : "medium"}
        fullWidth
        rows={5}
        variant={variant}
        // defaultValue={value}
        value={value || ' '}

        onChange={handleChange}
        helperText={errors[field.name] ? errors[field.name] : null}
        disabled={disabled}
      />
    </Tooltip>
  );
}
